import * as hooks from './hooks';

export const Conditions = () => {
    hooks.useTriggerOnAppInit();
    hooks.useTriggerBeforePageRendered();
    hooks.useTriggerAfterPageRendered();

    return null;
};
